export const API_VERSION = 'v1.0'
const HOST_URL = `lb.empirecinemas.com`
const LIVEBASEURL = `https://lb-cron.empirecinemas.com`

let DEVBASEURL = `http://localhost:3800`
let IMG_URL = `https://lb-cron.empirecinemas.com`

export const ImageS3URL = `https://images.brijimages.com/`
DEVBASEURL = `https://lb-cron.empirecinemas.com`

export const IMG_BASEURL = IMG_URL

export const BASEURL_BRIJ =
  window.location.host === HOST_URL ? LIVEBASEURL : DEVBASEURL

export const LB = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6ImU5MjliZTFmLTI1ZWMtNGQwNy05ZDZhLTZhY2U4MDFkMTY4MCIsImlhdCI6MTY5MzY2ODcyMX0.vQVV834q_Jfei7b7OL6hM6rFuL6Z1i1PxLhRqY_A9VE`

export const TOKEN = LB



// WEBPACK FOOTER //
// ./src/config/index.js